module.exports = __webpack_public_path__ + "media/images/front/columns_test_img_02-28c16f84266ac95cfbc49b095c990a80.png";